document.addEventListener("DOMContentLoaded", () => {
  const D = window.BOSTON_DATA;
  let currentUser = null;
  let currentTab = "menu";

  const login = document.getElementById("bostonLogin");
  const dash = document.getElementById("bostonDashboard");
  const content = document.getElementById("bostonContent");
  const search = document.getElementById("bostonSearch");
  const lang = document.getElementById("bostonLang");
  const cat = document.getElementById("bostonCategory");

  D.categories.forEach(c => {
    const opt = document.createElement("option");
    opt.value = c;
    opt.textContent = c;
    cat.appendChild(opt);
  });

  document.getElementById("bostonLoginBtn").onclick = () => {
    const u = document.getElementById("bostonUser").value.trim().toLowerCase();
    const p = document.getElementById("bostonPass").value.trim();
    const user = D.users[u];

    if (!user || user.pass !== p) {
      document.getElementById("bostonLoginError").textContent = "Benutzername oder Passwort falsch.";
      return;
    }

    currentUser = { key: u, ...user };
    localStorage.setItem("boston_user", JSON.stringify(currentUser));
    showDashboard();
  };

  document.getElementById("bostonLogout").onclick = () => {
    localStorage.removeItem("boston_user");
    location.reload();
  };

  document.querySelectorAll(".boston-tabs button").forEach(btn => {
    btn.onclick = () => {
      document.querySelectorAll(".boston-tabs button").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      currentTab = btn.dataset.tab;
      render();
    };
  });

  [search, lang, cat].forEach(el => el.addEventListener("input", render));

  const saved = localStorage.getItem("boston_user");
  if (saved) {
    currentUser = JSON.parse(saved);
    showDashboard();
  }

  function showDashboard() {
    login.classList.add("hidden");
    dash.classList.remove("hidden");
    document.getElementById("bostonRoleText").textContent =
      `${currentUser.name} · ${currentUser.role === "admin" ? "Admin" : "Nur Lesen"}`;
    render();
  }

  function t(item, key) {
    return item[`${key}_${lang.value}`] || item[key] || "";
  }

  function filteredProducts() {
    const q = search.value.toLowerCase();
    return D.products.filter(p => {
      const text = `${p.de} ${p.tr} ${p.cat} ${p.desc_de} ${p.desc_tr} ${p.station} ${(p.all || []).join(" ")}`.toLowerCase();
      return (!cat.value || p.cat === cat.value) && (!q || text.includes(q));
    });
  }

  function render() {
    if (currentTab === "menu") renderMenu();
    if (currentTab === "recipes") renderRecipes();
    if (currentTab === "raw") renderRaw();
    if (currentTab === "shopping") renderShopping();
    if (currentTab === "allergens") renderAllergens();
  }

  function renderMenu() {
    content.innerHTML = `<div class="boston-grid">${filteredProducts().map(p => `
      <div class="boston-card">
        ${p.image ? `<img class="boston-card-img" src="${p.image}" alt="${t(p,"de")}">` : `<div class="boston-card-img"></div>`}
        <div class="boston-card-body">
          <div class="boston-title">${lang.value === "tr" ? p.tr : p.de}</div>
          <div class="boston-sub">${p.cat} · ${p.station}</div>
          <p>${lang.value === "tr" ? p.desc_tr : p.desc_de}</p>
          ${(p.all || []).map(a => `<span class="boston-badge">${a}</span>`).join("")}
        </div>
      </div>
    `).join("")}</div>`;
  }

  function renderRecipes() {
    content.innerHTML = `<div class="boston-grid">${filteredProducts().map(p => `
      <div class="boston-card">
        <div class="boston-card-body">
          <div class="boston-title">${lang.value === "tr" ? p.tr : p.de}</div>
          <div class="boston-sub">Rezept wird aus Master-Datenbank ergänzt</div>
          <ul class="boston-list">
            <li>Station: ${p.station}</li>
            <li>Kategorie: ${p.cat}</li>
            <li>Allergene: ${(p.all || []).join(", ") || "Keine Angabe"}</li>
          </ul>
        </div>
      </div>
    `).join("")}</div>`;
  }

  function renderRaw() {
    const q = search.value.toLowerCase();
    const rows = D.raw.filter(r => !q || r.toLowerCase().includes(q));
    content.innerHTML = `<div class="boston-grid">${rows.map(r => `
      <div class="boston-card">
        <div class="boston-card-body">
          <div class="boston-title">${r}</div>
          <div class="boston-sub">Rohstoff · Einkaufspreis später eintragen</div>
          ${currentUser.role === "admin" ? `<button class="boston-action" onclick="addShopping('${r}')">Zur Einkaufsliste</button>` : ""}
        </div>
      </div>
    `).join("")}</div>`;
  }

  function renderShopping() {
    const list = JSON.parse(localStorage.getItem("boston_shopping") || "[]");
    content.innerHTML = `
      <button class="boston-action" onclick="shareShopping()">WhatsApp teilen</button>
      <button class="boston-action" onclick="clearShopping()">Liste löschen</button>
      <div style="height:12px"></div>
      ${list.map((x,i) => `
        <div class="boston-shopping-row">
          <b>${x.name}</b>
          <input placeholder="Menge z.B. 2">
          <select>
            <option>kg</option><option>g</option><option>Liter</option><option>ml</option><option>Stück</option><option>Schale</option><option>Karton</option>
          </select>
          ${currentUser.role === "admin" ? `<input placeholder="Preis €">` : ""}
        </div>
      `).join("") || "<p>Keine Artikel in der Einkaufsliste.</p>"}
    `;
  }

  function renderAllergens() {
    const allergens = [...new Set(D.products.flatMap(p => p.all || []))];
    content.innerHTML = allergens.map(a => `
      <div class="boston-card">
        <div class="boston-card-body">
          <div class="boston-title">${a}</div>
          <div class="boston-sub">
            ${D.products.filter(p => (p.all || []).includes(a)).map(p => lang.value === "tr" ? p.tr : p.de).join(", ")}
          </div>
        </div>
      </div>
    `).join("");
  }

  window.addShopping = function(name) {
    const list = JSON.parse(localStorage.getItem("boston_shopping") || "[]");
    list.push({ name });
    localStorage.setItem("boston_shopping", JSON.stringify(list));
    currentTab = "shopping";
    document.querySelectorAll(".boston-tabs button").forEach(b => b.classList.remove("active"));
    document.querySelector('[data-tab="shopping"]').classList.add("active");
    renderShopping();
  };

  window.clearShopping = function() {
    localStorage.removeItem("boston_shopping");
    renderShopping();
  };

  window.shareShopping = function() {
    const list = JSON.parse(localStorage.getItem("boston_shopping") || "[]");
    const text = "Boston Einkaufsliste:%0A" + list.map(x => "- " + x.name).join("%0A");
    window.open("https://wa.me/?text=" + text, "_blank");
  };
});